<template>
  <div class="container pt-0">
      <div class="flex mb-4 flex-wrap md:flex-col">
        <div class="w-full lg:w-1/2">
          <h2 class="w-full">Meine Daten</h2>
          <form>
          <div class="form-field sized">
            <label for="inputEmail">Email</label>
            <input
              v-model="userInfo.email"
              name="email" v-validate="'required|email'"
              :class="{'error': errors.has('email') }"
              type="text"
              data-vv-as="Email"
              placeholder="Email"
              id="inputEmail"
              @keyup.enter.prevent="updateData">
            <span v-show="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</span>
          </div>
          <div class="form-field sized">
            <label for="inputEmail">Vorname</label>
            <input
              v-model="userInfo.first_name"
              name="first_name"
              v-validate="'required'"
              :class="{'error': errors.has('first_name') }"
              type="text"
              data-vv-as="Vorname"
              placeholder="Vorname"
              id="inputName"
              @keyup.enter.prevent="updateData">
            <span v-show="errors.has('first_name')" class="errorMsg">{{ errors.first('first_name') }}</span>
          </div>
          <div class="form-field sized">
            <label for="inputEmail">Nachname</label>
            <input
              v-model="userInfo.last_name"
              name="last_name"
              v-validate="'required'"
              :class="{'error': errors.has('last_name') }"
              type="text"
              data-vv-as="Nachname"
              placeholder="Nachname"
              id="inputSurname"
              @keyup.enter.prevent="updateData">
            <span v-show="errors.has('last_name')" class="errorMsg">{{ errors.first('last_name') }}</span>
          </div>
          <label class="checkbox mt-1">
            <span>Bitte informiere mich über Neuigkeiten rund um couchgourmet</span>
            <input type="checkbox" v-model="userInfo.accepts_marketing">
            <span class="checkmark"></span>
          </label>
          <button class="btn orange" @click.prevent="updateData">Daten speichern</button>
          </form>
        </div>
        <div class="w-full lg:w-1/2">
          <h2 class="w-full">Mein Passwort</h2>
          <form>
          <div class="form-field sized">
            <label for="inputPassword">Neues Passwort</label>
            <input
              v-model="password"
              name="password"
              v-validate="'required|min:6|max:50'"
              :class="{'error': errors.has('password') }"
              type="password"
              data-vv-as="Passwort"
              placeholder="Passwort"
              id="inputPassword"
              @keyup.enter.prevent="updatePw">
            <span v-show="errors.has('password')" class="errorMsg">{{ errors.first('password') }}</span>
          </div>
          <div class="form-field sized">
            <label for="inputPasswordConfirmation">Passwort bestätigen</label>
            <input
              v-model="passwordConfirmation"
              name="passwordConfirmation"
              v-validate="'required|confirmed:password'"
              :class="{'error': errors.has('passwordConfirmation') }"
              type="password"
              data-vv-as="Passwort bestätigen"
              placeholder="Passwort bestätigen"
              id="inputPasswordConfirmation"
              @keyup.enter.prevent="updatePw">
            <span v-show="errors.has('passwordConfirmation')" class="errorMsg">{{ errors.first('passwordConfirmation') }}</span>
          </div>
          <button class="btn orange" @click.prevent="updatePw">Passwort speichern</button>
          </form>
          <button v-if="!account.is_verified" class="btn green toggable-button" @click.prevent="resendVerification">Verifizierungslink schicken</button>
        </div>
      </div>

    <user-address></user-address>

    <payment-methods></payment-methods>

  </div>
</template>

<script>
  import UserAddress from './userAddress'
  import PaymentMethods from './paymentMethods'
  import {mapGetters, mapActions} from 'vuex'

  export default {
    components: {PaymentMethods, UserAddress},
    name: 'profile',
    mounted () {
      var keys = Object.keys(this.userInfo)
      for (var i in keys) {
        if (this.account.hasOwnProperty(keys[i])) {
          this.userInfo[keys[i]] = this.account[keys[i]]
        }
      }
    },
    data () {
      return {
        userInfo: {
          email: '',
          first_name: '',
          last_name: '',
          accepts_marketing: false
        },
        password: '',
        passwordConfirmation: '',
        saveToast: null
      }
    },
    methods: {
      changeTab (tab) {
        this.tab = tab
      },
      ...mapActions([
        'updateUser',
        'updatePassword',
        'resendVerificationLink'
      ]),
      updateData () {
        var vm = this
        vm.userInfo.user = vm.account.uid
        vm.userInfo.cb = () => {
          vm.$toasted.success('Deine Daten wurden aktualisiert.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        vm.userInfo.errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          vm.updateUser(vm.userInfo)
        }
      },
      resendVerification () {
        var vm = this
        let data = {}
        data.cb = () => {
          vm.$toasted.success('Eine Email wurde verschickt.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        data.errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Eine Email wird verschickt...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          vm.resendVerificationLink(data)
        }
      },
      updatePw () {
        var vm = this
        let data = {}
        data.password = vm.password
        data.user = vm.account.uid
        data.cb = () => {
          vm.$toasted.success('Dein Passwort wurde aktualisiert.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        data.errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          vm.updatePassword(data)
        }
      }
    },
    computed: {
      ...mapGetters({
        'account': 'auth_get_account'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/profile.vue